import { format } from 'date-fns';

const getListOfPluginName = plugins => {
  const pluginText = [];
  plugins.forEach(p => {
    pluginText.push(p.name);
  });
  return pluginText.toString();
};

const isDoNotTrackEnabled = () => {
  const doNotTrackOption =
    window.doNotTrack || window.navigator.doNotTrack || window.navigator.msDoNotTrack;

  if (!doNotTrackOption) {
    return false;
  }

  return doNotTrackOption.charAt(0) === '1' || doNotTrackOption === 'yes';
};

export const submissionsConfig = () => ({
  gov_client_timezone: `UTC${format(new Date(), 'xxx')}`,
  gov_client_window_size: `width=${window.screen.width}&height=${window.screen.height}`,
  gov_client_browser_plugins: getListOfPluginName(navigator.plugins),
  gov_client_browser_js_user_agent: navigator.userAgent,
  gov_client_screens: `width=${window.screen.width}&height=${window.screen.height}&scaling-factor=${window.devicePixelRatio}&colour-depth=${window.screen.colorDepth}`,
  gov_client_browser_do_not_track: isDoNotTrackEnabled(),
});
